import TagManager from 'react-gtm-module';

import {
  DeferredNavigationProps,
  deferredNavigationFields,
} from './clickTracking';

export interface TrackBrandTileClickProps extends DeferredNavigationProps {
  data: {
    interactionLocation: string;
    linkUrl: string;
    coOpBrand: string | null;
    index: number;
    heading: string;
  };
}

export const trackBrandTileClick = ({
  data,
  ...deferral
}: TrackBrandTileClickProps) => {
  const { interactionLocation, linkUrl, coOpBrand, index, heading } = data;

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'click_brand_tile',
      interaction: {
        interaction_location: interactionLocation,
        heading,
        link_url: linkUrl,
        coop_brand: coOpBrand,
        index,
      },
      ...deferredNavigationFields(deferral),
    },
  });
};
